<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">
                {{ meta.title }}
                <div v-if="isRequiered" class="dx-field-item-required-mark">&nbsp;*</div>
            </div>
            <div :class="fieldValueClass">
                <ai-number-box
                    ref="aiTextBoxRef"
                    v-model:value="value"
                    :meta="meta"
                    @input="input"
                    :read-only="isReadOnly"
                />
                <div
                    v-if="error"
                    class="ai-dx-invalid"
                    @click="() => callbacks.notifyErrorMessage(error.message)"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue';
import AiNumberBox from '@/components/ai-number-box.vue';

const aiTextBoxRef = ref();
const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
    readOnly: {
        type: Boolean,
        default: false,
    },
    empty: {
        type: Boolean,
        default: false,
    }
});

const userData = inject('userData');
const serverData = inject('serverData');
const validationResult = inject('validationResult');

const input = eventArgs => {
    userDataChange(eventArgs.newText);
};

const modified = computed(() => {
    return (
        userData.value[props.meta.fieldNameText]?.toString() !== serverData.value[props.meta.fieldNameText]?.toString()
    );
});

const isRequiered = computed(() => {
    return props.meta.validationRules?.required;
});

const error = computed(() => {
    return validationResult.value.find(s => s.fieldNameText === props.meta.fieldNameText);
});

const isReadOnly = computed(() => {
    return props.meta?.readOnly ? props.meta?.readOnly : props.readOnly;
})

const isEmpty = computed(() => {
    return props.meta?.empty ? props.meta?.empty : props.empty;
})

const userDataChange = newData => {
    validationResult.value = validationResult.value.filter(s => {
        return s.fieldNameText !== props.meta.fieldNameText;
    });
    userData.value[props.meta.fieldNameText] = newData;
    props.callbacks.userDataChanged();
};

const value = computed({
    get: () => {
        if (!userData.value[props.meta.fieldNameText]) {
            return isEmpty.value ? null : 0;
        }
        return userData.value[props.meta.fieldNameText];
    },
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
        'ai-field-modified': modified.value,
    };
});
defineExpose({ aiTextBoxRef });
</script>

